export default __webpack_public_path__ + "static/media/e.a7b0c2e9.svg";